import { baseUrl } from "API/baseURL";
import { refreshAccessToken } from "API/tokenManager";
import { message } from "antd";
import axios from "axios";

export const apiInstance = axios.create({
  baseURL: baseUrl,
});

apiInstance.interceptors.request.use(
  async function (config) {
    const accessToken = localStorage.getItem("accessToken");
    config.headers.Authorization = accessToken
      ? "Bearer " + accessToken
      : undefined;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiInstance.interceptors.response.use(
  function (response) {
    return response.data;
  },
  async function (error) {
    const originalRequest = error.config;

    // On 401, attempt a silent token refresh and retry once
    if (error.response?.status === 401 && !originalRequest._retried) {
      originalRequest._retried = true;
      const newToken = await refreshAccessToken();
      if (newToken) {
        originalRequest.headers.Authorization = "Bearer " + newToken;
        return apiInstance(originalRequest);
      }
    }

    if (error.response?.status === 400) {
      return error.response.data;
    } else if (typeof error.response?.data?.message === "string") {
      message.error(error.response.data.message);
    } else if (error.response?.data?.message) {
      for (let i = 0; i < error.response.data.message.length; i++) {
        message.error(error.response.data.message[i]);
      }
    }
    return Promise.reject(error);
  }
);
